<template>
  <section class="upload-spv tw-mt-10 tw-relative">
    <Loader v-if="loading" />
    <div class="upload-spv__container">
      <div class="upload-spv-heading__div tw-mb-12 tw-mt-12">
        <h1 class="upload-spv__heading tw-font-bold tw-text-xl tw-mb-1">
          Upload SPV
        </h1>
        <p class="tw-text-sm tw-text-black-light">
          Provide a valid SPV document. File should be in docx or pdf format.
        </p>
      </div>
      <form
        @submit.prevent="startUpload = true"
        class="upload-spv__form tw-p-6 tw-pb-8"
      >
        <h2
          class="create-deal__heading tw-text-secondary tw-flex tw-items-center tw-mb-4 tw-font-bold"
        >
          <img src="@/assets/img/file.svg" class="tw-mr-2" alt="file icon" />
          SPV Document
        </h2>
        <div class="">
          <DragNDrop
            class="upload-spv__dragdrop"
            accept=".pdf"
            :currentValue="spv"
            @file-added="setSpv"
            :startUpload="startUpload"
            @reupload="startUpload = false"
            @upload-complete="addSpv"
          >
            <!-- <p
              class="tw-text-sm tw-text-secondary tw-w-full tw-text-center tw-mb-2"
              v-if="!spv"
            >
              Drag and drop file
            </p> -->
          </DragNDrop>
          <p class="tw-text-sm tw-text-black-light tw-text-center tw-mb-6">
            Document should be good condition and clearly visible.
          </p>
          <hr class="upload-spv__dragdrop" />
          <div class="tw-w-full tw-mt-8 upload-spv__dragdrop">
            <div class="tw-w-32">
              <CustomButton
                title="Submit"
                class="tw-text-sm"
                :disabled="!$route.params || !$route.params.id || !spv"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
  import DragNDrop from "@/components/general/DragNDrop";
  import CustomButton from "@/components/general/BtnComponent";
  import { mapActions } from "vuex";
  export default {
    name: "SpvUpload",
    data() {
      return {
        spv: null,
        loading: false,
        startUpload: false,
      };
    },
    components: {
      DragNDrop,
      CustomButton,
    },
    watch: {
      startUpload(val) {
        if (val) {
          this.loading = true;
        }
      },
    },
    methods: {
      ...mapActions("Spv", ["uploadSpv"]),
      ...mapActions(["showToast"]),
      setSpv(val) {
        this.spv = val;
      },
      async addSpv(url) {
        this.spv = url;
        const obj = {
          spv: {
            documents: [
              {
                name: "Spv Document",
                url: this.spv,
                type: "Spv Document",
              },
            ],
          },
          id: this.$route.params.id,
        };
        try {
          const response = await this.uploadSpv(obj);
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.loading = false;
          this.$router.push({
            name: "PrivateRaiseInfo",
            params: {
              id: this.$route.params.id,
            },
          });
        } catch (error) {
          this.loading = false;
          return error;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .upload-spv {
    border-radius: 4px;
    &__container {
      max-width: 818px;
      margin-left: auto;
      margin-right: auto;
    }
    &__form {
      background: #ffffff;
      border: 1px solid #f1f3f6;
      box-sizing: border-box;
      border-radius: 4px;
      margin-bottom: 100px;
    }
    &__dragdrop {
      margin-left: auto;
      margin-right: auto;
      max-width: 690px;
    }
  }
</style>
